module.exports = __webpack_public_path__ + "img/total_look.banner.c3463cdd.jpg";